export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const MODAL_INIT_STATE = {
    isOpen: false,
    content: <></>,
    style: null
};
